import ModalsContainer from './Modals.container';
import reducer from './redux/reducer';
import * as actions from './redux/actionCreators';
import Modals from './Modals';

export default ModalsContainer(Modals);
export { reducer, actions };
export { type Props } from './Modals';
